<template>
    <s-card class="dashboard-header-charts__card h-100" style="cursor: initial;">
        <!-- Header Chart Normal -->
        <s-card-header v-if="chart.data != null" :style="loading?'opacity: 0.1;pointer-events: none;':''" class="dashboard-header-charts__header border-bottom">
            <p class="font-weight-bold">{{chartType == 'method_payment' ? 'Method Payement' : chartType == 'platforms' ? 'Platforms' : 'Sign Up'}}</p>
        </s-card-header>
        <!-- Body Chart Normal -->
        <s-card-body v-show="chart.data" class="p-0 dashboard-header-charts__body-chart mb-2" style="height: calc(100% - 70px) !important;">
            <canvas :style="loading?'opacity: 0.1;pointer-events: none;':'position:absolute;'" class="w-100 dashboard__body--chart" ref="canvas"></canvas>
        </s-card-body>

        <!-- Body Chart Loader -->
        <s-card-body style="top:0;height:100%;" v-show="loading" class="p-0 dashboard-header-charts__body-chart w-100 text-center">
            <div v-if="loading" class="loader-chart" style="opacity: 1 !important;z-index:8;">
                <s-loader :type="'scalify'"></s-loader>
            </div>
        </s-card-body>

    </s-card>
</template>

<script>

import Chart from 'chart.js';
// import moment from 'moment';
export default {
  name: 'pie-chart',

  components:{
  },

  props:['chartType','startDate','endDate','updateDate'],

  watch:{
    updateDate:{
        deep:true,
        handler(){
            if (this.updateDate != null) {
                this.startDate = this.updateDate.startDate;
                this.endDate = this.updateDate.endDate;
                this.changesInChart();
            }
        }
    }
  },

  data(){
    return{
      loading:false,
      chart: {
          chartID: null,
          showPlatformMetric:false,
          loadingChart: false,
          chartcanvas: null,
          showMetric: false,
          data:null,
          topDropDownMetrics: 20,
          listSelected: [],
          settingMetric: false,
          metric: null
      },
      dataChart: null,
      colorsChart: {"bigcommerce":"#34313F","facebook":"#3C87FF","google":"#FFC04B","Others":"#9FB3CA","paypal":"#3C87FF","shopify":"#3FC886","stripe":"#874FFD"},
      currentChart:null
    }
  },
  methods:{
      async changesInChart(){
        if (this.chart.chartcanvas != null) {
            this.loading = true;
            try{

                let metric = this.chartType;

                let chartData = await this.getChartsPie(metric, this.startDate, this.endDate)

                // console.log('chartData: ', chartData);
                this.chart.data = {dataLabel:[], dataCharts:[], backgroundColor:[]}

                chartData.data.map((row)=>{
                  let platform;
                  if (row.method) {
                    platform = row.method;
                    this.chart.data.dataLabel.push(this.capitalize(row.method.replace("_"," ")))
                  }else{
                    platform =  row.platform == null ? 'Others' : row.platform
                    this.chart.data.dataLabel.push(this.capitalize(platform.replace("_"," ")))
                  }
                  this.chart.data.dataCharts.push(row.count)
                  this.chart.data.backgroundColor.push(this.colorsChart[platform]);
                })

                this.dataChart.labels = this.chart.data.dataLabel;
                this.dataChart.datasets[0].data = this.chart.data.dataCharts;
                this.dataChart.datasets[0].backgroundColor = this.chart.data.backgroundColor;

                this.chart.chartcanvas.update();

                this.loading = false;
            }
            catch(err){
                this.loading = false;
            }

        }
    },
  },

  async mounted(){

    this.loading = true
    this.chart.loadingChart = true;

    this.chart.chartID = this.$refs.canvas;
    try{

        let metric = this.chartType;
        // console.log('metric: ', metric);
        let chartData = await this.getChartsPie(metric, this.startDate, this.endDate)

        // console.log('chartData: ', chartData);
        this.chart.data = {dataLabel:[], dataCharts:[], backgroundColor:[]}

        chartData.data.map((row)=>{
          let platform;
          if (row.method) {
            platform = row.method;
            this.chart.data.dataLabel.push(this.capitalize(row.method.replace("_"," ")))
          }else{
            platform =  row.platform == null ? 'Others' : row.platform
            this.chart.data.dataLabel.push(this.capitalize(platform.replace("_"," ")))
          }
          this.chart.data.dataCharts.push(row.count)
          this.chart.data.backgroundColor.push(this.colorsChart[platform]);
        })
        // console.log('this.chart.data.dataCharts: ', this.chart.data.dataCharts);
        this.dataChart = {
            labels: this.chart.data.dataLabel,
            datasets: [{ data:this.chart.data.dataCharts, backgroundColor: this.chart.data.backgroundColor}]
        }

        this.chart.chartcanvas = new Chart(this.chart.chartID, {
            type: 'pie',
            data: this.dataChart,
            options: {
                // tooltips: {
                //     mode: 'index', intersect: false,
                //     backgroundColor: '#FFFFFF', titleFontFamily: 'Walsheim Pro', titleFontSize: 14, titleFontColor: '#52749C',
                //     titleMarginBottom: 10, bodyFontFamily: 'arial' , bodyFontSize: 14, bodyFontColor: '#52749C', bodySpacing: 5, xPadding: 15, yPadding: 15, bodyFontStyle: '500', caretSize: 0, borderColor: 'rgba(42, 140, 255, 0.27)', borderWidth: 1,caretPadding: 10
                // },
                // hover: {
                //     mode: 'index',intersect: false,
                //     onHover: function(e) {
                //         var point = this.getElementAtEvent(e);
                //         if (point.length){ e.target.style.setProperty('cursor','pointer','important');
                //         }else{ e.target.style.setProperty('cursor','default','important');}
                //     }
                // },
                maintainAspectRatio: false,
                onResize: ()=>{
                    this.chart.chartcanvas.update();
                },
            }
        });

        this.chart.loadingChart = false;
    }
    catch(err){
        this.chart.loadingChart = false;
        this.handleErrors(err)
    }

    this.loading = false
  },




}
</script>

<style scoped>

</style>
